import { cancelCart } from "@/apps/merchant3/services/carts.service";
import { logEcommerceEvent } from "@/apps/merchant3/helpers/offers/ecommerce-event-log";
import EventLogs from "@/apps/merchant3/types/EventLogs";
import { store } from "@/shared-store";
import { Store } from "vuex";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";
import {
  clearStoreAndNavigateHome,
  doRedirection,
  getRedirectToAdminPageUrl,
} from "@/apps/merchant3/helpers/redirect.helper";
import cancelCartState from "@/apps/merchant3/hooks/cancelCartState";
import { SessionStorageEnum } from "@/apps/merchant3/enums/sessionStorageEnum";
import { EcommerceUrlReturnCodes } from "@/apps/merchant3/types/EcommerceUrlReturnCodes";

export const cancelCartAndClearStore = async (
  reason: string
): Promise<void> => {
  const vuexStore = store as unknown as Store<IVuexState>;
  const cartTag = vuexStore?.state.carts?.cartTag || "";
  const step = vuexStore?.state.carts?.step || "";
  if (!cartTag || !step) {
    return;
  }

  await logEcommerceEvent(EventLogs.Events.ECOMMERCE_CANCELED);
  await cancelCart(cartTag, step, reason);
  await clearStoreAndNavigateHome();
};

export const cancelCartFromSmileFlow = async (step = ""): Promise<void> => {
  const cartTag = sessionStorage.getItem(SessionStorageEnum.CartTag);

  if (!cartTag || !step) {
    return;
  }

  await cancelCart(
    cartTag,
    step,
    "Sale Explicitly Canceled due to SMILE registration cancellation"
  );

  const redirectUrl = getRedirectToAdminPageUrl(
    EcommerceUrlReturnCodes.CANCELED,
    cartTag
  );

  await cancelCartState();
  doRedirection(undefined, redirectUrl);
};
